// extracted by mini-css-extract-plugin
export default {"nav":"nav-tab_nav__DPmPm","list":"nav-tab_list__oZt+H","verticalList":"nav-tab_verticalList__2c+IQ"};